<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {

  /* margin-top: 60px; */
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue